import axios from 'axios'
import { getBaseUrl } from '@/helpers/Utils';

const baseURL = import.meta.env.VITE_API_BASE_URL || getBaseUrl()

export const apiClient = axios.create({
    baseURL: `${baseURL}/api`,
    headers: {'Accept': 'application/json'}
});
